import { darken, linearGradient } from "polished";
import styled from "styled-components";
import { Absolute, Block } from "components";
import { MicroInteractionStyles, focusOutlineStyles } from "styles";

export const AnimatedBlock = styled(Block)`
  ${MicroInteractionStyles};
`;
AnimatedBlock.displayName = "AnimatedBlock";

export const ImageOverlay = styled(Absolute)`
  ${MicroInteractionStyles};
  ${({ isHovered, theme }) =>
    isHovered ? theme.imageOverlayHover : theme.imageOverlay};
`;
ImageOverlay.defaultProps = {
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  zIndex: 0
};

export const HoverCard = styled(Block)`
  ${MicroInteractionStyles};
  color: inherit;
  transition-property: border, box-shadow;
  transform: translateZ(0);

  &:link,
  &:visited {
    color: currentColor;
    text-decoration: none;
  }

  @media (hover:none) and (pointer: coarse) {
    border-color: ${({ hoverColor }) => hoverColor};
    
    &:link,
    &:visited {
      color: ${({ theme }) => theme.colors.textOnDark};
    }
  }

  @media (hover) and (pointer: fine) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ hoverColor }) => hoverColor};
      color: ${({ theme }) => theme.colors.textOnDark};
      box-shadow: ${({ theme }) => theme.shadows.elevation3};
    }
  }

  ${({ hoverColor }) => focusOutlineStyles(hoverColor)};
  }
`;
HoverCard.defaultProps = {
  bg: "surfaceMuted",
  borderColor: "borderPrimary",
  borderStyle: "solid",
  borderWidth: 1,
  boxShadow: "elevation1",
  display: "block"
};
HoverCard.displayName = "HoverCard";

export const createGradient = color =>
  linearGradient({
    colorStops: [`${color} 25%`, `${darken(0.12, color)} 75%`],
    toDirection: "to top"
  });

export const createLightGradient = color =>
  linearGradient({
    colorStops: [`transparent 50%`, `${color} 100%`],
    toDirection: "to bottom"
  });
